import axios from 'axios'
import Environments from '../environments/Environment';

var http = null;

//Documentacion de la api
//https://api.copomex.com/documentacion/inicio

class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.COPOMEX,
            headers: { 'Content-Type': 'application/json' },
        });
    }

    getInfoByEstado(cp) {
        return new Promise((success, error) => {
            http.get(`/info_cp/${cp}?type=simplified&token=${Environments.TOKENCOPOMEX}`)
                .then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
                }).catch(function(err) {
                    if (err.response) {
                        error(err.response.data);
                    } else if (err.request) {
                        error(err.request);
                    } else {
                        error(err.message);
                    }
                });
            // console.log(error.config);
        });
    }

    getMunicipiosByEstado(estado) {
        return new Promise((success, error) => {
            http.get(`/get_municipio_por_estado/${estado}?token=${Environments.TOKENCOPOMEX}`)
                .then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
                }).catch(function(err) {
                    if (err.response) {
                        error(err.response.data);
                    } else if (err.request) {
                        error(err.request);
                    } else {
                        error(err.message);
                    }
                });
            // console.log(error.config);
        });
    }

    getColoniaByMunicipio(municipio) {
        return new Promise((success, error) => {
            http.get(`/get_colonia_por_municipio/${municipio}?token=${Environments.TOKENCOPOMEX}`)
                .then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
                }).catch(function(err) {
                    if (err.response) {
                        error(err.response.data);
                    } else if (err.request) {
                        error(err.request);
                    } else {
                        error(err.message);
                    }
                });
            // console.log(error.config);
        });
    }

    getCp(estado, municipio, colonia) {
        return new Promise((success, error) => {
            http.get(`/get_cp_advanced/${estado}?limit=10&municipio=${municipio}&colonia=${colonia}&token=${Environments.TOKENCOPOMEX}`)
                .then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
                }).catch(function(err) {
                    if (err.response) {
                        error(err.response.data);
                    } else if (err.request) {
                        error(err.request);
                    } else {
                        error(err.message);
                    }
                });
            // console.log(error.config);
        });
    }
}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/Copomex.js